import Pointer from "../../Components/Pointer";



export default function ReadNav({getNextSlide, getPrevSlide}) {



    return (
        <div className="ReadNav text-white items-center flex flex-row justify-between">
            <div className={`text-2xl`}>Featured Articles</div>
            <div className="arrowGroup flex flex-row gap-2">
                <Pointer direction={"left"} bgColor={"purple-slumber"} task={getPrevSlide}  />
                <Pointer direction={"right"} bgColor={"purple-slumber"} task={getNextSlide}  />
            </div>
        </div>
    );
}


